// extracted by mini-css-extract-plugin
module.exports = {"container":"OMsSO","header":"Jf3SO","scrollable":"_3pO22","disableScroll":"_3g-SC","content":"_1IJFX","isAnimated":"_3N0vo"};